import { Pipe, PipeTransform } from '@angular/core';
import { VoucherAtpHandlerHtmlService } from './voucher-atp-handler-html.service';
import { FormGroup } from '@angular/forms';
import { FormGroupContextBase } from '../models/FormModels';
import { FormGroupAtpHtml } from '../models/HtmlModels';

@Pipe({
  name: 'contextBaseToAtpHtml',
  pure: true,
  standalone: false
})
export class ContextBaseToAtpHtmlPipe implements PipeTransform {
  constructor(private voucherAtpHandlerHtmlService: VoucherAtpHandlerHtmlService) {}

  transform(formGroup: FormGroup<FormGroupContextBase>): FormGroupAtpHtml[] {
    return [this.voucherAtpHandlerHtmlService.createFormGroupFromHtml(formGroup.controls.name.value, formGroup)];
  }
}
